const learnTask = {
  state: {
    taskNum: ''
  },
  mutations: {
    setLearnTaskNum (state, taskNum) {
      state.taskNum = taskNum
    }
  }
}

export default learnTask
